<script>
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import Headline from '@components/headline.vue';
import Text from '@components/text.vue';
import Card from '@components/card.vue';

export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    components: { Card, Text, Headline, VerticalAlignChildrenWrapper },
    props: {
        forbiddenRoute: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<template>
    <Card card-icon="ban" card-color="red">
        <VerticalAlignChildrenWrapper v-if="forbiddenRoute && forbiddenRoute.path">
            <Text v-if="forbiddenRoute.meta.title" gap="1">Du hast keine Berechtigung für: {{ forbiddenRoute.meta.title }}</Text>
            <Headline>Dir fehlt die Rolle: {{ forbiddenRoute.meta.role }}</Headline>
        </VerticalAlignChildrenWrapper>
        <template v-else>Du hast keine Berechtigung diese Funktion zu nutzen.</template>
    </Card>
</template>
